// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "@radix-ui/react-avatar", "../../common/utils", "../Typography"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("@radix-ui/react-avatar"), require("../../common/utils"), require("../Typography"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.reactAvatar, global.utils, global.Typography);
    global.Avatar = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, AvatarPrimitive, _utils, _Typography) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.AvatarImage = _exports.AvatarFallback = _exports.Avatar = void 0;
  _react = _interopRequireWildcard(_react);
  var React = _react;
  AvatarPrimitive = _interopRequireWildcard(AvatarPrimitive);
  var _excluded = ["className"],
    _excluded2 = ["className"],
    _excluded3 = ["className"];
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
  function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
  function getBorderRadius(size, variant) {
    if (variant === 'circle') {
      return 'cop-rounded-full';
    }
    switch (size) {
      case 'sm':
        return 'cop-rounded';
      case 'md':
        return 'cop-rounded';
      case 'lg':
        return 'cop-rounded-md';
      case 'xl':
        return 'cop-rounded-lg';
      default:
        (0, _utils.ensureUnreachable)(size);
    }
  }
  var Avatar = _exports.Avatar = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
    var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);
    var _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      variant = props.variant,
      fallbackColor = props.fallbackColor;
    var AVATAR_SIZE_MAP = {
      sm: 'cop-h-5 cop-w-5',
      md: 'cop-h-7 cop-w-7',
      lg: 'cop-h-10 cop-w-10',
      xl: 'cop-h-16 cop-w-16'
    };
    var avatarSize = AVATAR_SIZE_MAP[size];
    var avatarSizeWithBorder = "".concat(avatarSize, " ").concat(getBorderRadius(size, variant));
    var TEXT_SIZE_MAP = {
      sm: 'xs',
      md: 'sm',
      lg: 'lg',
      xl: '2xl'
    };
    var getTextColorFromFallbackColor = function getTextColorFromFallbackColor(color) {
      var colorHex = color.replace('#', '');
      var r = parseInt(colorHex.substr(0, 2), 16);
      var g = parseInt(colorHex.substr(2, 2), 16);
      var b = parseInt(colorHex.substr(4, 2), 16);
      var brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness >= 128 ? 'cop-text-primary' : 'cop-text-white';
    };
    var textColor = fallbackColor ? getTextColorFromFallbackColor(fallbackColor) : 'cop-text-primary';
    var memoizedStyles = React.useMemo(function () {
      if (fallbackColor) {
        return {
          backgroundColor: fallbackColor
        };
      }
      return {};
    }, [fallbackColor]);
    return /*#__PURE__*/React.createElement(AvatarPrimitive.Root, _extends({
      ref: ref,
      className: (0, _utils.cn)("cop-relative cop-flex cop-border cop-border-solid cop-border-card-border ".concat(avatarSizeWithBorder, " cop-shrink-0 cop-overflow-hidden cop-bg-avatar-gray ").concat(textColor), className),
      style: memoizedStyles
    }, props), 'src' in props && /*#__PURE__*/React.createElement(AvatarImage, {
      src: props.src,
      alt: props.alt
    }), 'text' in props && /*#__PURE__*/React.createElement(AvatarFallback, null, /*#__PURE__*/React.createElement(_Typography.Heading, {
      variant: TEXT_SIZE_MAP[size]
    }, props.text)));
  });
  Avatar.displayName = AvatarPrimitive.Root.displayName;
  var AvatarImage = _exports.AvatarImage = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
    var className = _ref2.className,
      props = _objectWithoutProperties(_ref2, _excluded2);
    return /*#__PURE__*/React.createElement(AvatarPrimitive.Image, _extends({
      ref: ref,
      className: (0, _utils.cn)('cop-aspect-square cop-h-full cop-w-full', className)
    }, props));
  });
  AvatarImage.displayName = AvatarPrimitive.Image.displayName;
  var AvatarFallback = _exports.AvatarFallback = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
    var className = _ref3.className,
      props = _objectWithoutProperties(_ref3, _excluded3);
    return /*#__PURE__*/React.createElement(AvatarPrimitive.Fallback, _extends({
      ref: ref,
      className: (0, _utils.cn)('cop-bg-muted cop-flex cop-h-full cop-w-full cop-items-center cop-justify-center cop-rounded-full', className)
    }, props));
  });
  AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;
});
